import React from 'react';

import classnames from 'classnames';

import MenuItem from '@mui/material/MenuItem';

import HorizontalScroller from 'components/uiLibrary/HorizontalScroller';
import SelectDropdown from 'components/uiLibrary/Inputs/SelectDropdown';
import LinkButton from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Typography from 'components/uiLibrary/Typography';

import { useTranslation } from 'src/i18n';

import { CASTING_RESULT_TYPES_VALUES } from 'operabase-router/constants';

import classes from './TabsNavigation.module.scss';

const TabsNavigation = ({
  className,
  activeTab,
  tabs,
  trackingData,
  handleOnClick,
  ns,
  asDropdown = false,
  variant,
  hasAccessToFilters,
}) => {
  const { t } = useTranslation(ns);

  if (asDropdown) {
    const value = tabs?.find(tab => tab?.key === activeTab);

    const getTextColor = optionKey => {
      if (variant === 'orange') {
        return 'orange';
      }

      if (optionKey === activeTab) {
        return 'white';
      }

      return 'primary';
    };

    return (
      <SelectDropdown
        options={tabs}
        value={value}
        onChange={(e, currentTab) => {
          const tabValue = tabs?.find(tab => tab?.key === currentTab?.value);

          if (typeof handleOnClick === 'function') {
            handleOnClick(tabValue, e);
          }
        }}
        styles={{
          select: classnames(classes.select, {
            [classes.select__dark]: variant === 'dark',
            [classes.select__orange]: variant === 'orange',
          }),
          formControl: classes.formControl,
          paper: classes.paper,
        }}
        renderValue={option => t(option?.title)}
      >
        {({ options }) =>
          options?.map(option => (
            <MenuItem
              key={option?.key}
              value={option?.key}
              className={classnames(classes.menuItem, {
                [classes.menuItem__active]: option?.key === activeTab,
                [classes.menuItem__orange]: variant === 'orange',
              })}
            >
              <Typography
                size={12}
                color={getTextColor(option?.key)}
                weight={option?.key === activeTab ? 'medium' : 'regular'}
                className={classnames(classes.isActive, {
                  [classes.isActive__orange]: variant === 'orange',
                })}
                truncate
              >
                {t(option?.title)}
              </Typography>
              <SpriteIcon icon="chevron_right" size={16} className={classes.arrowIcon} />
            </MenuItem>
          ))
        }
      </SelectDropdown>
    );
  }

  return (
    <nav>
      <HorizontalScroller hideArrow>
        <div className={classnames(classes.navigation, className)}>
          {tabs.map(tab => {
            const showLockIcon = tab.key === CASTING_RESULT_TYPES_VALUES.JUMP_IN && !hasAccessToFilters;

            return (
              <LinkButton
                variant="grey"
                shape="rectangle"
                active={activeTab && activeTab === tab.key}
                leftIcon={
                  showLockIcon ? <SpriteIcon icon="lock_black_24dp" size={14} className={classes.lockIcon} /> : null
                }
                styles={{
                  root: classnames(classes.navigation__tab, {
                    [classes.navigation__tab_active]: activeTab && activeTab === tab.key,
                    [classes.navigation__tab_activeDark]: activeTab && activeTab === tab.key && variant === 'dark',
                    [classes.navigation__tab_dark]: variant === 'dark',
                  }),
                }}
                {...tab.linkProps}
                key={tab.key}
                onClick={e => {
                  if (typeof handleOnClick === 'function') {
                    handleOnClick(tab, e);
                  }
                }}
                stopPropagation
                disableUnderline
                disableHover
                {...(tab?.linkProps?.href && { isLink: true })}
                trackingData={{
                  ...trackingData,
                  meta: {
                    tab: tab?.key,
                  },
                }}
              >
                {t(tab.title)}
              </LinkButton>
            );
          })}
        </div>
      </HorizontalScroller>
    </nav>
  );
};

export default TabsNavigation;
